import { zhCN as addinTokenBalance } from './addinTokenBalance';

export default {
    usageManagement: {
        page: {
            title: '系统管理中心',
            description: '管理用户使用量、模型配置、工具配置和 Langfuse Prompt',
        },
        tabs: {
            overview: '会话监控',
            usage: '用户使用量',
            model: '模型配置',
            ocrModel: 'OCR模型选择',
            tool: '工具配置',
            prompt: 'Prompt 管理',
            feedback: 'Feedback 管理',
            payment: '支付统计',
            tokenUsage: 'Token 使用量',
            addinTokenBalance: '插件 Token 余额',
            report: '统计报表',
            userActivityReport: '日活报表',
            assetStats: '资产统计',
            documentStats: '文档统计',
            skill: 'Skill 管理',
            role: '人员管理',
            companyQuota: '公司配额',
            userQuota: '用户配额',
            funnel: '用户漏斗',
            oarCallLog: '第三方OAR调用',
        },
        addinTokenBalance,
        overview: {
            metrics: {
                totalSessions: '总会话数',
                avgDuration: '平均会话时长',
                avgRounds: '平均对话轮数',
                successRate: '任务成功率',
                activeUsers: '活跃用户数',
            },
            date: { today: '今天', yesterday: '昨天', last3days: '最近3天', last7days: '最近7天' },
            refresh: '刷新',
            table: {
                sessionId: '会话ID', user: '用户', email: '邮箱', ip: '归属地',
                rounds: '对话轮数', duration: '持续时长', successFailure: '成功/失败',
                startTime: '开始时间', copy: '复制', intranet: '内网',
            },
            drawer: {
                title: '会话详情', sessionId: '会话ID', user: '用户', email: '邮箱',
                taskId: '任务ID', status: '状态', ip: 'IP', duration: '耗时', startTime: '开始时间',
            },
            copied: '已复制',
            searchEmail: '搜索用户邮箱',
            userTypeAll: '全部用户',
            userTypeInternal: '内部用户',
            userTypeExternal: '外部用户',
            userTypePlg: 'PLG 用户',
            export: '导出数据',
            exportSuccess: '导出成功',
            exportFailed: '导出失败',
            exportHeaders: {
                user: '用户',
                userId: '用户ID',
                sessionId: '会话ID',
                ip: 'IP地址',
                rounds: '对话轮数',
                duration: '持续时长',
                success: '成功次数',
                failure: '失败次数',
                startTime: '开始时间',
            },
            exportFilename: '会话监控_{date}.csv',
        },
        usage: {
            config: {
                title: '全局配置', baseTab: '基础配置', visitorLimit: '游客每日限制', accountLimit: '免费用户限制',
                userTaskConcurrencyLimit: '付费用户单用户并发限制',
                globalTaskConcurrencyLimit: '付费用户全局并发限制',
                freeUserTaskConcurrencyLimit: '免费用户单用户并发限制',
                freeGlobalTaskConcurrencyLimit: '免费用户全局并发限制',
                aiCallsPerMinuteLimit: '模型调用每分钟并发限制',
                aiCallsCurrentCount: '当前 AI 调用数（本分钟）',
                aiCallsCurrentCountUnit: '次',
                save: '保存配置', hint: '提示：修改后将应用于所有新用户',
            },
            metrics: {
                totalUsage: '今日总使用', avgUsage: '平均使用次数', avgPerUser: '平均 {n} 次/人',
                activeUsers: '活跃用户数', activeRate: '{n}% 活跃率',
                exceededUsers: '超限用户数', exceededRate: '{n}% 超限率',
            },
            date: { today: '今天', yesterday: '昨天', last3days: '最近3天', last7days: '最近7天', placeholder: '选择日期' },
            toolbar: {
                searchPlaceholder: '搜索用户邮箱', sortField: '排序字段', sortOrder: '排序方向',
                sortByCount: '使用次数', sortByUserId: '用户 ID', sortDesc: '降序', sortAsc: '升序', refresh: '刷新',
            },
            table: {
                title: '用户使用量列表', export: '导出数据', user: '用户', count: '使用次数',
                limit: '限制', usageRate: '使用率', remaining: '剩余', status: '状态', action: '操作',
                copyEmail: '复制邮箱', copyId: '复制 ID', total: '共 {n} 条记录',
                empty: '暂无用户数据', emptyHint: '等待用户开始使用对话功能',
            },
            status: { exceeded: '超限', warning: '接近', normal: '正常' },
            customLimit: {
                tag: '自定义',
                setLimit: '设置限制',
                reset: '恢复默认',
                dialogTitle: '设置用户每日限制',
                user: '用户',
                dailyLimit: '每日限制',
                remark: '备注',
                remarkPlaceholder: '备注（可选）',
                cancel: '取消',
                confirm: '确认',
                setSuccess: '用户限制设置成功',
                setFailed: '设置失败',
                removeSuccess: '已恢复为全局默认限制',
                removeFailed: '操作失败',
            },
            export: {
                account: '账号', userId: '用户ID', company: '公司名称', count: '使用次数',
                limit: '限制', remaining: '剩余', status: '状态',
                success: '导出成功', filename: '用户使用统计_{date}.csv',
            },
            copied: '已复制',
        },
        report: {
            refresh: '刷新',
            timeWindowDefault: '默认 5分钟',
            timeWindow: {
                '5min': '5分钟', '30min': '30分钟', '60min': '60分钟',
                today: '今天', last7days: '近7天', last30days: '近30天',
                last3months: '近3个月', last6months: '近半年', last1year: '近一年',
                minutes: '{n}分钟',
                all: '全部',
            },
            userStatsTitle: '用户统计',
            taskStatsTitle: '任务统计',
            filters: {
                users: '筛选用户',
                companies: '筛选公司',
                agents: '筛选Agent类型',
                searchUser: '搜索用户邮箱',
                searchCompany: '搜索公司名',
                agentTypes: {
                    disclosure: '交底书',
                    patentDraft: '专利申请',
                    prosecution: '审查意见书',
                },
            },
            userMetrics: {
                dau: '日活用户（DAU）',
                mau: '月活用户（MAU）',
                uv: '独立访客（UV）',
                pv: '页面浏览量（PV）',
                avgDuration: '平均会话时长',
                avgTokensPerMessage: '次均Token数',
                avgTokensComparison: '次均Token数/次均附图Token数',
                newUsers: '日新增用户',
                totalCumulativeUsers: '累计用户数',
                churnedUsers: '流失用户数',
                returnedUsers: '回流用户数',
                weeklyRetentionRate: '活跃周留存',
                avgRoundsPerMatter: '平均任务对话轮数',
                avgMattersPerUser: '人均Matter数',
                copilotRatio: '助手模式占比',
                agentRatio: '智能体模式占比',
                snapshotHint: '快照',
                mauDisabledHint: '月粒度下生效',
                weeklyRetentionDisabledHint: '周粒度下生效',
                dauTooltip: '今日（自然日 00:00 起）产生有效操作的去重用户数',
                mauTooltip: '近 30 天内产生有效操作的去重用户数（固定快照）',
                uvTooltip: '所选时间范围内访问并产生有效操作的去重用户数',
                pvTooltip: '所选时间范围内发起的对话总数',
                newUsersTooltip: '今日首次产生有效操作的用户数，即历史上从未出现过的新用户',
                totalCumulativeUsersTooltip: '历史上曾产生过有效操作的去重用户总数（实时快照）',
                churnedUsersTooltip: '累计用户中，过去 7 天内无任何有效操作的用户数（实时快照）',
                returnedUsersTooltip: '今日活跃用户中，此前连续 7 天无有效操作、今日重新活跃的用户数',
                weeklyRetentionRateTooltip: '上周（自然周）活跃用户中，本周再次产生有效操作的用户占比（%）',
                avgRoundsPerMatterTooltip: '所选时间范围内，对话总轮数 ÷ Matter 总数',
                avgTokensPerMessageTooltip: '所选时间范围内，（输入 + 输出）Token 总数 ÷ 对话总轮数',
                avgTokensComparisonTooltip: '次均Token数 = 所选时间范围内（输入 + 输出）Token 总数 ÷ 对话总轮数；次均附图Token数 = 附图 Token 总数 ÷ 有附图 Token 消耗的项目数',
                modeRatioTooltip: '所选时间范围内，助手模式（Copilot）/ 智能体模式（Agent）的 Matter 数各占 Matter 总数的百分比',
            },
            userCharts: {
                tokenTask: 'Token消耗 & 任务数趋势',
                dauMau: 'DAU/MAU 趋势',
                uvPv: 'UV & PV 趋势',
                avgDuration: '平均会话时长趋势',
                avgConversations: '人均对话数趋势',
                avgTokensPerMessage: '次均Token数趋势',
                avgConversationToken: '人均对话数 / 次均Token数趋势',
                agentUsage: '各Agent使用次数',
                tokenLabel: 'Token消耗',
                attachmentTokenLabel: '附图Token消耗',
                taskLabel: '任务数',
                dauLabel: '日活（DAU）',
                mauLabel: '月活（MAU）',
                uvLabel: '独立访客（UV）',
                pvLabel: '页面浏览量（PV）',
                avgDurationLabel: '平均会话时长',
                avgConversationsLabel: '人均对话数',
                avgTokensPerMessageLabel: '次均Token数',
                avgConversationsAxis: '对话数',
                agentUsageLabel: '使用次数',
                agentUsageAxis: '次数',
            },
            metrics: {
                workers: '在线 Worker', activeTasks: '活跃任务',
                successRate: '成功率', totalTasks: '总任务({window})', avgDuration: '平均耗时',
            },
            chart: { title: '任务趋势', empty: '暂无趋势数据', total: '总量', success: '成功', failure: '失败' },
            byType: {
                title: '任务类型分布', type: '类型', total: '总数',
                success: '成功', failure: '失败', successRate: '成功率', avgDuration: '平均耗时',
            },
            activeTasks: {
                title: '当前活跃任务', fallback: '降级模式', empty: '当前无活跃任务',
                worker: 'Worker', taskType: '任务类型', runtime: '运行时长', taskId: '任务ID',
            },
        },
        tokenUsage: {
            title: '用户 Token 使用量列表',
            summary: { users: '用户数', totalTokens: '总 Token', totalMessages: '总消息数', totalTasks: '总任务数', avgTokensPerTask: '平均 Token / 任务' },
            filter: {
                timeWindowPlaceholder: '选择时间窗口', statusPlaceholder: '任务状态',
                statusAll: '全部状态', statusSuccess: '成功', statusFailure: '失败',
                statusStarted: '执行中', statusPending: '等待中',
                searchPlaceholder: '搜索用户邮箱',
                sortByTokens: 'Total Token', sortByMessages: '消息数', sortByTasks: '任务数',
                sortDesc: '降序', sortAsc: '升序', refresh: '刷新',
                expandAll: '展开全部', collapseAll: '折叠全部',
            },
            timeWindow: {
                '5min': '5分钟', '10min': '10分钟', '30min': '30分钟', '1h': '1小时',
                today: '今天', last7days: '最近7天', last30days: '最近30天',
            },
            table: {
                user: '用户', totalTokens: 'Token 用量', messages: '消息数', tasks: '任务数',
                conversations: '会话数', conversation: '会话', convTokens: '会话 Token', status: '状态', ip: 'IP',
                actualTokens: '真实 Token', createdAt: '创建时间', empty: '暂无 Token 使用数据',
            },
            pagination: { total: '共 {n} 个用户' },
            copied: '已复制',
        },
        ocrModel: {
            title: 'OCR模型选择',
            current: '当前保存模型',
            save: '保存配置',
            reset: '重置',
            unsaved: '有未保存的更改',
            loadFail: '加载 OCR 模型配置失败',
            saveSuccess: 'OCR 模型配置保存成功',
            saveFail: '保存 OCR 模型配置失败',
            options: {
                glm: { label: 'GLM', desc: 'GLM 文档解析' },
                mineru: { label: 'MinerU', desc: 'MinerU 文档解析' },
                smart_doc: { label: 'SmartDoc', desc: 'SmartDoc 文档解析' },
            },
        },
        creditParam: {
            title: 'Credit参数',
            current: '当前保存值',
            enabledLabel: 'CREDITS_ENABLED',
            enabledDesc: '控制配额耗尽后是否允许进入积分扣费兜底。',
            on: '开启',
            off: '关闭',
            save: '保存配置',
            reset: '重置',
            unsaved: '有未保存的更改',
            loadFail: '加载 Credit 参数失败',
            saveSuccess: 'Credit 参数保存成功',
            saveFail: '保存 Credit 参数失败',
        },
        model: {
            agentSection: 'Agent 主模型配置', agentCount: '{n} 个 Agent',
            taskSection: '任务级模型覆盖', taskCount: '{n} 项',
            modelLabel: '模型', modelPlaceholder: '搜索或选择模型',
            tempLabel: '温度 ({val})', tempPlaceholder: '温度', maxTokensPlaceholder: '不限制',
            maxOutput: '最大输出 {n}', maxTemp: '温度上限 {n}',
            multimodal: '多模态', thinking: '推理',
            multimodalSupport: '支持多模态', thinkingSupport: '支持推理',
            fallbackModelLabel: '备用模型', fallbackModelPlaceholder: '不配置（熔断时不切换）',
            taskHeader: { task: '任务', model: '模型', temp: '温度', fallback: '备用模型' },
            categories: { drafting: '专利撰写', prosecution: '答复文件', rag: '文档处理', image: '图像分析', general: '通用任务', style: '风格提取' },
            save: '保存配置', undoEdit: '撤销编辑', resetDefault: '恢复默认', unsaved: '有未保存的更改',
            loadFail: '加载模型配置失败', saveSuccess: '模型配置保存成功', saveFail: '保存模型配置失败',
            undoDone: '已撤销未保存的编辑',
            resetConfirmMsg: '将清除所有自定义配置，恢复为系统默认值。此操作不可撤销。',
            resetConfirmTitle: '确认恢复默认', resetConfirmBtn: '恢复默认', resetCancel: '取消',
            resetSuccess: '已恢复为系统默认配置', resetFail: '恢复默认配置失败',
        },
        tool: {
            baseTools: '基础工具（不可配置）', specificTools: '专属工具（可配置）',
            itemCount: '{n} 项', required: '必需', noSpecificTools: '该 Agent 暂无专属工具',
            save: '保存配置', reset: '重置', unsaved: '有未保存的更改',
            loadFail: '加载工具配置失败', saveSuccess: '工具配置保存成功',
            saveFail: '保存工具配置失败', resetDone: '已重置为上次保存的配置',
        },
        proLimit: {
            title: 'Pro 用户文档数量限制',
            patentDraftLimit: '专利撰写限制',
            disclosureLimit: '交底书限制',
            oarLimit: '审查意见限制',
            unit: '篇',
            saveSuccess: 'Pro 文档限制保存成功',
            saveFail: '保存失败',
            loadFail: '加载失败',
        },
        freeLimit: {
            title: 'Free 用户文档数量限制',
            totalDocumentLimit: '文档总量限制',
            patentDraftLimit: '专利撰写限制',
            disclosureLimit: '交底书限制',
            oarLimit: '审查意见限制',
            unit: '篇',
            saveSuccess: 'Free 文档限制保存成功',
            saveFail: '保存失败',
            loadFail: '加载失败',
        },
        prompt: {
            config: {
                title: 'Langfuse 配置',
                publicKeyLabel: 'Public Key', secretKeyLabel: 'Secret Key', hostLabel: 'Host URL（可选）',
                testConnection: '测试连接', loadPrompts: '加载所有 Prompts',
                checkSync: '检查同步状态', batchPush: '批量推送',
                clearCache: '清除所有缓存',
                promptNamePlaceholder: '输入 Prompt 名称', fetch: '获取',
                missingKeys: '请输入 Public Key 和 Secret Key',
                connectSuccess: '连接成功！', connectFail: '连接失败: {msg}',
                loadSuccess: '成功加载 {n} 个 Prompts', loadFail: '加载 Prompts 失败: {msg}',
                fetchFail: '获取 Prompt 失败: {msg}', promptNameRequired: '请输入 Prompt 名称',
                connectFirst: '请先测试连接', loadFirst: '请先加载前端 Prompts',
            },
            list: {
                title: 'Prompt 管理', count: '共 {n} 个', searchPlaceholder: '搜索 prompts...',
                loading: '正在加载 Prompts...', empty: '暂无 Prompts 数据', reload: '重新加载',
                colName: '名称', colType: '类型', colLabels: '标签',
                colSyncStatus: '同步状态', colActions: '操作',
                view: '查看', push: '推送', synced: '已同步', unchecked: '未检查',
                delete: '删除',
                deleteBackend: '删除目标端',
            },
            orphan: {
                tag: '源端已删除',
                banner: '检测到 {n} 个 prompt 仅在目标端存在（源端已删除），建议清理',
            },
            delete: {
                confirmTitle: '删除 Prompt',
                confirmContent: '确认删除 prompt 「{name}」吗？将删除目标 Langfuse 中的所有版本并清理 Redis 缓存，此操作不可恢复。',
                confirmOrphanTitle: '删除目标端 Prompt',
                confirmOrphanContent: '源 Langfuse 已不存在 prompt 「{name}」，目标 Langfuse 仍保留。确认从目标端删除并清理 Redis 缓存？',
                forceConfirmTitle: 'Langfuse 删除失败',
                forceConfirmContent: 'Langfuse 删除失败：{msg}。是否仍强制清理 Redis 缓存？',
                confirm: '确认删除',
                confirmOrphan: '删除目标端',
                forceConfirm: '强制清缓存',
                cancel: '取消',
                success: '删除成功：{name}（已清理 {n} 个缓存 keys）',
                fail: '删除 {name} 失败：{msg}',
            },
            cache: {
                clearAllTitle: '清除所有 Prompt 缓存',
                clearAllContent: '确认清除 Redis 中所有 Prompt 缓存吗？下次请求将从 Langfuse 重新拉取。',
                confirm: '确认清除',
                clearSuccess: '清除成功，共清理 {n} 个缓存 keys',
                clearFail: '清除缓存失败：{msg}',
            },
            sync: {
                same: '已同步', different: '需更新', frontendOnly: '待推送', backendOnly: '仅后端',
                checkDone: '同步状态检查完成！共检查 {total} 个 - 已同步: {same}, 需更新: {diff}, 待推送: {pending}, 仅后端: {backend}',
                checkFail: '检查同步状态失败: {msg}',
            },
            push: {
                dialogTitle: '推送 Prompts 到后端', selected: '共选择 {n} 个需要推送的 Prompts',
                overwrite: '覆盖已存在的 Prompts',
                pushing: '正在分批推送中，每批最多5个 Prompts...',
                cancel: '取消', pushBtn: '推送 ({n})', nothingToPush: '没有需要推送的 Prompts',
                batchInfo: '正在推送第 {cur}/{total} 批 ({n} 个 Prompts)...',
                batchDone: '第 {n} 批推送完成！成功: {success}, 失败: {fail}',
                allDone: '所有批次推送完成！总计 - 成功: {success}, 失败: {fail}, 跳过: {skip}',
                pushFail: '推送失败: {msg}',
                singleSuccess: '{name} 推送成功！', singleSkipped: '{name} 推送被跳过',
                singleFail: '推送 {name} 失败: {msg}',
            },
            detail: {
                name: '名称', type: '类型', version: '版本', labels: '标签',
                content: 'Prompt 内容：', fetchFail: '获取 Prompt 详情失败: {msg}',
            },
        },
        assetStats: {
            totalTemplates: '总模板数',
            totalInstructions: '总指令数',
            totalStyles: '总风格数',
            startDate: '开始日期',
            endDate: '结束日期',
            searchUser: '搜索用户邮箱',
            user: '用户',
            templates: '模板数',
            instructions: '指令数',
            styles: '风格数',
            all: '全部',
            today: '今天',
            yesterday: '昨天',
            last7days: '最近7天',
            last30days: '最近30天',
            refresh: '刷新',
            tableTitle: '资产统计列表',
            empty: '暂无数据',
            copied: '已复制',
            total: '共 {n} 条记录',
        },
        documentStats: {
            docGroup: '文档统计',
            assetGroup: '资产统计',
            totalDocuments: '总文档数',
            totalExports: '总导出次数',
            startDate: '开始日期',
            endDate: '结束日期',
            searchUser: '搜索用户邮箱',
            searchUserBatch: '邮箱或用户ID，多个用逗号分隔',
            searchCompany: '搜索公司名称',
            user: '用户',
            userId: '用户ID',
            company: '公司',
            email: '邮箱',
            disclosure: '交底书',
            patentDraft: '专利申请',
            prosecution: '审查意见书',
            totalCount: '总文档数',
            exportCount: '导出次数',
            templateCount: '模板数',
            instructionCount: '指令数',
            styleCount: '风格数',
            folderCount: '文件夹数',
            totalTemplates: '总模板数',
            totalInstructions: '总指令数',
            totalStyles: '总风格数',
            totalFolders: '总文件夹数',
            all: '全部',
            today: '今天',
            yesterday: '昨天',
            last7days: '最近7天',
            last30days: '最近30天',
            custom: '自定义',
            refresh: '刷新',
            tableTitle: '资产统计列表',
            empty: '暂无数据',
            copied: '已复制',
            total: '共 {n} 条记录',
            userTypeAll: '全部用户',
            userTypeExternal: '外部用户',
            userTypePlg: 'PLG 用户',
            userIdentity: '用户身份',
            userIdentityAll: '全部身份',
            userIdentityAnonymous: '匿名用户',
            userIdentityFree: '免费用户',
            userIdentityPro: 'Pro 用户',
            userIdentityMax: 'Max 用户',
            userIdentityEnterprise: '企业用户',
            firstDraftingStartedAt: '首次开始使用Drafting时间',
            registeredAt: '注册时间',
            currentPlanStartedAt: '当前套餐开始时间',
            latestActiveAt: '最近活跃时间',
            filterTimeRange: '时间范围',
            filterUser: '用户筛选',
            search: '查询',
            reset: '重置',
            bulkSearch: '批量搜索',
            bulkSearchHint: '每行一个邮箱，或用逗号、空格分隔',
            uploadFile: '上传文件',
            uploadFileHint: '支持 .xlsx / .xls / .csv，第一列为邮箱',
            dropZoneText: '拖拽 Excel / CSV 文件到此处，或点击上传',
            emailInputPlaceholder: '输入邮箱，按回车添加',
            recognizedCount: '已识别 {n} 个邮箱',
            clearAll: '清空',
            cancel: '取消',
            emailCount: '{n} 个邮箱',
            importedCount: '已导入 {n} 个邮箱',
            clearImport: '清除',
            export: '导出',
            exportAll: '导出全部',
            exportSelected: '导出选中',
            selectedCount: '已选 {n} 项',
            exportSuccess: '导出成功',
            parseError: '文件解析失败',
            noEmailFound: '未找到有效邮箱',
        },
        email: {
            sendEmail: '发送邮件',
            dialogTitle: '发送运营邮件',
            recipientCount: '将发送给 {n} 位用户',
            promptLabel: '邮件需求',
            promptPlaceholder: '请描述邮件内容需求，例如：写一封产品更新通知邮件，介绍我们新上线的 AI 撰写功能...',
            promptRequired: '请输入邮件需求',
            generate: '生成邮件',
            generating: '生成中...',
            generateFailed: 'AI 生成失败，请重试',
            aiGenerate: 'AI 生成',
            emailInfo: '邮件信息',
            recipients: '位收件人',
            templates: '邮件模板',
            noTemplates: '暂无模板，可通过 AI 生成后保存为模板',
            saveAsTemplate: '保存为模板',
            templateName: '模板名称',
            templateNamePlaceholder: '输入模板名称',
            templateDesc: '模板描述',
            templateDescPlaceholder: '可选，简要描述模板用途',
            templateNameRequired: '请输入模板名称',
            templateSaved: '模板保存成功',
            templateSaveFailed: '模板保存失败',
            templateDeleted: '模板已删除',
            templateDeleteFailed: '模板删除失败',
            save: '保存',
            selectTemplate: '选择邮件模板...',
            deleteTemplate: '删除模板',
            bodyContent: '邮件正文',
            bodyPlaceholder: 'HTML 正文片段，会自动注入品牌邮件外壳...',
            subject: '邮件主题',
            subjectPlaceholder: '请输入邮件主题',
            content: '邮件内容',
            contentRequired: '请填写邮件主题和内容',
            preview: '预览',
            source: '源码',
            back: '返回',
            cancel: '取消',
            confirmSend: '确认发送',
            sending: '发送中...',
            sendSuccess: '邮件发送任务已提交',
            sendFailed: '邮件发送失败',
            emailed: '已发邮件',
            sent: '已发',
            opened: '已读',
            notEmailed: '未发邮件',
            emailStatusAll: '邮件状态',
            emailStatusSent: '已发送',
            emailStatusNotSent: '未发送',
            noEmailWarning: '以下用户无邮箱地址，将被跳过',
            previewEmpty: '输入需求并点击生成，邮件预览将显示在这里',
            sendHistory: '发送记录',
            sendHistoryDesc: '查看所有邮件发送记录和收件人状态',
            noHistory: '暂无发送记录',
        },
        feedback: {
            title: '用户反馈管理',
            totalCount: '共 {n} 条',
            searchEmail: '搜索用户邮箱',
            statusPlaceholder: '状态',
            categoryPlaceholder: '分类',
            priorityPlaceholder: '优先级',
            refresh: '刷新',
            emptyText: '暂无反馈数据',
            colUser: '用户',
            colTitle: '标题',
            colCategory: '分类',
            colStatus: '状态',
            colPriority: '优先级',
            colTime: '提交时间',
            copyEmail: '复制邮箱',
            copyId: '复制 ID',
            copyProjectId: '复制 Project ID',
            copied: '已复制',
            paginationTotal: '共 {n} 条',
            delete: '删除',
            deleteConfirm: '确定要删除这条反馈吗？此操作不可撤销。',
            batchDeleteConfirm: '确定要删除选中的 {n} 条反馈吗？此操作不可撤销。',
            batchDelete: '批量删除',
            selectedCount: '已选 {n} 条',
            deleteTitle: '删除反馈',
            deleteBtn: '删除',
            deleteCancel: '取消',
            deleteSuccess: '删除成功',
            colAction: '操作',
            status: {
                pending: '待处理',
                processing: '处理中',
                resolved: '已解决',
                closed: '已关闭',
            },
            category: {
                bug: '缺陷',
                suggestion: '建议',
                feature_request: '功能请求',
                other: '其它',
            },
            priority: {
                high: '高',
                medium: '中',
                low: '低',
            },
            drawer: {
                statusLabel: '状态',
                priorityLabel: '优先级',
                statusPending: '待处理',
                statusProcessing: '处理中',
                statusResolved: '已解决',
                statusClosed: '已关闭',
                priorityHigh: '高',
                priorityMedium: '中',
                priorityLow: '低',
                adopt: '采纳',
                adoptDisabledTip: '已创建 {key}，不可重复采纳',
                noMessages: '暂无消息记录',
                replyPlaceholder: '输入回复内容，Enter 换行，Ctrl+Enter 发送...',
                replyHint: 'Ctrl+Enter 快速发送',
                sendReply: '发送回复',
                statusLabelPending: '待处理',
                statusLabelProcessing: '处理中',
                statusLabelResolved: '已解决',
                statusLabelClosed: '已关闭',
                categoryBug: '缺陷',
                categorySuggestion: '建议',
                categoryFeatureRequest: '功能请求',
                categoryOther: '其它',
                priorityHighLabel: '高优先级',
                priorityMediumLabel: '中优先级',
                priorityLowLabel: '低优先级',
            },
            jiraDialog: {
                title: '创建 Jira Bug',
                summary: '标题',
                summaryPlaceholder: '请输入 Bug 标题',
                description: '描述',
                descriptionPlaceholder: '请输入 Bug 描述',
                reporter: '反馈人',
                company: '公司',
                priority: '优先级',
                priorityHigh: '高',
                priorityMedium: '中',
                priorityLow: '低',
                category: '分类',
                assignee: '经办人',
                labels: '标签',
                components: '组件',
                clientName: 'Client Name',
                customerLevel: 'Customer Level',
                cancel: '取消',
                confirm: '确认创建',
                creating: '创建中...',
                success: 'Jira Bug 创建成功',
                failed: 'Jira Bug 创建失败',
            },
        },
        modelConfig: {
            groupLabel: '配置组',
            activeTag: '激活',
            inactiveTag: '未激活',
            activateSwitch: '设为激活',
            activeHint: '当前配置已激活，切换并激活其他配置以后会自动禁用此配置。',
            create: '新建',
            rename: '重命名',
            delete: '删除',
            createDialogTitle: '新建配置组',
            nameLabel: '名称',
            namePlaceholder: '如 GPT优先、经济模式',
            copyFromLabel: '复制自',
            copyFromPlaceholder: '不复制（空配置）',
            cancel: '取消',
            createBtn: '创建',
            renameDialogTitle: '重命名配置组',
            renamePlaceholder: '新名称',
            save: '保存',
            switchSuccess: '已切换配置组',
            switchFail: '切换配置组失败',
            nameRequired: '请输入配置组名称',
            createSuccess: '配置组创建成功',
            createFail: '创建失败',
            updateSuccess: '配置组已更新',
            updateFail: '更新失败',
            deleteConfirmMsg: '确定删除配置组「{name}」？此操作不可撤销。',
            deleteConfirmTitle: '删除配置组',
            deleteConfirmBtn: '删除',
            deleteSuccess: '配置组已删除',
            deleteFail: '删除失败',
        },
        langfuse: {
            connectionFallback: '连接失败',
            connectionFailMsg: '连接失败: {msg}',
            connectFirst: '请先测试连接',
            promptNameRequired: '请输入 Prompt 名称',
        },
        payment: {
            totalCount: '总笔数',
            totalAmount: '总金额 (USD)',
            records: '支付记录',
            total: '共 {n} 条',
            searchPlaceholder: '搜索邮箱/套餐',
            startDate: '开始日期',
            endDate: '结束日期',
            refresh: '刷新',
            emptyText: '暂无支付记录',
            user: '用户',
            plan: '套餐',
            amount: '金额',
            cycle: '周期',
            time: '时间',
            monthly: '月付',
            yearly: '年付',
            loadFailed: '加载支付记录失败',
            statsFailed: '加载统计失败',
        },
        oarCallLog: {
            totalCalls: '总调用次数',
            summaryTitle: '月度汇总（对账用）',
            allMonths: '全部月份',
            summaryByService: '按服务细分',
            service: '服务',
            subtotal: '小计',
            records: '调用明细',
            total: '共 {n} 条',
            searchPlaceholder: '搜索申请号/用户ID',
            projectIdPlaceholder: '按项目ID筛选',
            allServices: '全部服务',
            allStatuses: '全部状态',
            startDate: '开始日期',
            endDate: '结束日期',
            refresh: '刷新',
            emptyText: '暂无调用记录',
            applicationNumber: '申请号',
            userId: '用户ID',
            projectId: '项目ID',
            status: '状态',
            retryCount: '重试次数',
            responseCode: '响应码',
            resultLength: '结果字符数',
            errorMessage: '错误信息',
            createdAt: '创建时间',
            loadFailed: '加载调用记录失败',
            statsFailed: '加载统计失败',
        },
        skill: {
            patentOffice: '受理局',
            mode: '模式',
            modeAgent: '完整模式',
            modeCopilot: '轻量模式',
            disclosure: '交底书',
            patentDraft: '专利申请',
            prosecution: '审查意见答复',
            empty: '暂无数据',
            loadFailed: '加载失败',
            save: '保存',
            reset: '重置',
            saveSuccess: '保存成功',
            saveFailed: '保存失败',
            editor: { edit: '编辑', split: '分屏', preview: '预览' },
        },
        skillDb: {
            title: 'Skill 管理（数据库）',
            create: '创建 Skill',
            searchPlaceholder: '搜索名称或描述',
            draftingType: '撰写类型',
            patentOffice: '专利局',
            category: '分类',
            all: '全部',
            colName: '名称',
            colType: '类型',
            colOffice: '专利局',
            colField: '技术领域',
            colCategory: '分类',
            colUsage: '使用次数',
            colActions: '操作',
            edit: '编辑',
            duplicate: '复制',
            delete: '删除',
            editTitle: '编辑 Skill',
            createTitle: '创建 Skill',
            fieldName: '名称',
            fieldCategory: '分类',
            fieldPublic: '公开',
            fieldDescription: '描述',
            fieldDraftingType: '撰写类型',
            fieldPatentOffice: '专利局',
            fieldTechField: '技术领域',
            fieldContent: '内容（Markdown）',
            cancel: '取消',
            save: '保存',
            loadFailed: '加载 Skill 失败',
            createSuccess: '创建成功',
            updateSuccess: '更新成功',
            saveFailed: '保存失败',
            deleteTitle: '删除',
            deleteConfirm: '确定删除 Skill「{name}」？',
            deleteSuccess: '删除成功',
            duplicateSuccess: '复制成功',
            duplicateFailed: '复制失败',
            tabBasic: '基础信息',
            colRefs: '引用',
            refCreate: '添加 Reference',
            refEditTitle: '编辑 Reference',
            refCreateTitle: '添加 Reference',
            refUpdateSuccess: 'Reference 已更新',
            refCreateSuccess: 'Reference 已创建',
            refDeleteConfirm: '确定删除 Reference「{name}」？',
        },
        role: {
            searchPlaceholder: '搜索邮箱',
            search: '搜索',
            assign: '分配角色',
            email: '邮箱',
            role: '角色',
            assignedBy: '分配人',
            remark: '备注',
            createdAt: '创建时间',
            action: '操作',
            remove: '移除',
            assignTitle: '分配角色',
            cancel: '取消',
            confirm: '确认',
        },
        funnel: {
            title: '用户转化漏斗',
            refresh: '刷新',
            metrics: {
                anonymous: 'Guest 用户',
                free: 'Basic 用户',
                pro: 'Pro 用户',
                enterprise: 'Enterprise 用户',
            },
            chart: {
                funnelTitle: '转化漏斗',
                empty: '暂无数据',
            },
            table: {
                title: '转化明细',
                level: '层级',
                count: '用户数',
                percentage: '占比',
                conversionRate: '转化率',
                churn: '流失',
                baseline: '基准',
            },
            timeWindow: {
                all: '全部',
                '60min': '60分钟',
                today: '今天',
                last7days: '近7天',
                last30days: '近30天',
                last3months: '近3个月',
                last6months: '近半年',
                last1year: '近一年',
            },
        },
        userDetail: {
            title: '用户详情',
            userId: '用户 ID',
            company: '公司',
            sectionDocStats: '文档统计',
            sectionTokenUsage: 'Token 用量',
            sectionSessions: '会话记录',
            sectionUsageLimits: '用量限额',
            disclosure: 'Disclosure',
            patentDraft: 'Patent Draft',
            prosecution: 'Prosecution',
            totalDocs: '文档总数',
            exports: '导出',
            templates: '模板',
            instructions: '指令',
            styles: '风格',
            folders: '文件夹',
            totalTokens: 'Token 总量',
            totalMessages: '消息总数',
            taskCount: '任务数',
            conversationId: '会话',
            tokens: 'Tokens',
            messages: '消息',
            rounds: '轮次',
            duration: '时长',
            successFailure: '成功 / 失败',
            startTime: '开始时间',
            chatCount: '对话次数',
            limit: '限额',
            customLimit: '自定义限额',
            remaining: '剩余',
            exceeded: '已超限',
            normal: '正常',
            noData: '暂无数据',
            copied: '已复制',
        },
        userQuota: {
            title: '用户文档配额管理',
            description: '在全局配置的基础上，为特定用户增加文档创建额度',
            searchPlaceholder: '搜索邮箱',
            addQuota: '添加配额',
            editQuota: '编辑配额',
            userId: '用户ID',
            email: '用户邮箱',
            documentType: '文档类型',
            quotaAdjustment: '增加额度',
            remark: '备注',
            createdAt: '创建时间',
            actions: '操作',
            edit: '编辑',
            delete: '删除',
            save: '保存',
            cancel: '取消',
            noData: '暂无用户配额数据',
            confirmDelete: '确定要删除该用户的文档配额调整吗？',
            confirmDeleteTitle: '确认删除',
            deleteSuccess: '删除成功',
            saveSuccess: '保存成功',
            patent_draft: '专利撰写',
            disclosure: '技术交底书',
            prosecution: '审查意见答复',
            total: '文档总量',
            adjustmentHint: '在全局配置基础上额外增加的文档数量',
            userIdRequired: '请输入用户ID',
            emailRequired: '请输入用户邮箱',
            documentTypeRequired: '请选择文档类型',
            adjustmentRequired: '请输入增加额度',
        },
    },
};
